import { createContext } from 'react';

const CoursesContext = createContext();

export default CoursesContext;